// Safari did not ship requestIdleCallback / cancelIdleCallback until 18.4.
// Fall back to setTimeout for older versions.
if (typeof window.requestIdleCallback !== 'function') {
  window.requestIdleCallback = (cb) =>
    window.setTimeout(
      () => cb({ didTimeout: false, timeRemaining: () => 50 }),
      1
    );
  window.cancelIdleCallback = (id) => {
    window.clearTimeout(id);
  };
}
